export default __webpack_public_path__ + "static/media/ElementsImg.05fd4969.jpg";